__turbopack_context__.v({
  "action": "BoatDocuments-module-scss-module__ZfNplG__action",
  "boatDocumentsWrapper": "BoatDocuments-module-scss-module__ZfNplG__boatDocumentsWrapper",
  "content": "BoatDocuments-module-scss-module__ZfNplG__content",
  "item": "BoatDocuments-module-scss-module__ZfNplG__item",
  "tags": "BoatDocuments-module-scss-module__ZfNplG__tags",
  "text": "BoatDocuments-module-scss-module__ZfNplG__text",
});
